import { ProfileRole } from '../types'
// TODO: Limpiar archivo
export type ProfileSectionId =
  | 'basic'
  // | 'avatar'
  // | 'genre'
  | 'studentInfo'
  | 'professorInfo'
  | 'adminInfo'
  // | 'userType'
  | 'credentials'

export type ProfileSection = {
  id: ProfileSectionId
  title: string
  description?: string
}

export const buildProfileSections = (role: ProfileRole) => {
  const base: ProfileSection[] = [
    { id: 'basic', title: 'Datos Personales' },
    // { id: 'avatar', title: 'Foto de perfil' },
    // { id: 'genre', title: 'Genero' },
  ]

  if (role === 'student') base.push({ id: 'studentInfo', title: 'Alumno' })
  if (role === 'professor')
    base.push({ id: 'professorInfo', title: 'Profesor' })
  if (role === 'admin') base.push({ id: 'adminInfo', title: 'Admin' })
  base.push({ id: 'credentials', title: 'Credenciales de acceso' })
  // if (isNewUser) base.push({ id: 'userType', title: 'Rol' })

  return base
}
